import { Injectable } from '@angular/core';
import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest
} from '@angular/common/http';
import { Observable, throwError, TimeoutError } from 'rxjs';
import { catchError, timeout } from 'rxjs/operators';
const DEFAULT_REQUEST_TIMEOUT_MS = 20_000;
const UPLOAD_REQUEST_TIMEOUT_MS = 60_000;

@Injectable()
export class ApiTimeoutInterceptor implements HttpInterceptor {
  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    // HttpClient should never leave a product screen waiting forever. Apply the
    // deadline to every programmatic request, including local API aliases.
    const timeoutMs = request.body instanceof FormData ? UPLOAD_REQUEST_TIMEOUT_MS : DEFAULT_REQUEST_TIMEOUT_MS;

    return next.handle(request).pipe(
      timeout(timeoutMs),
      catchError((error: unknown) => {
        if (error instanceof TimeoutError) {
          return throwError(() => new HttpErrorResponse({
            error: {
              code: 'API_TIMEOUT',
              message: 'The service did not respond in time. Please try again.'
            },
            status: 504,
            statusText: 'Gateway Timeout',
            url: request.url
          }));
        }

        return throwError(() => error);
      })
    );
  }
}
